/**
 * @generated SignedSource<<92658f7f3020989c21df0e6bce1d86f6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type pricingGuidanceHelpers_viewer$data = {
  readonly pdpSiderailSoldPricingGuidanceLinkFF: boolean | null;
  readonly " $fragmentType": "pricingGuidanceHelpers_viewer";
};
export type pricingGuidanceHelpers_viewer$key = {
  readonly " $data"?: pricingGuidanceHelpers_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"pricingGuidanceHelpers_viewer">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "pricingGuidanceHelpers_viewer"
};

(node as any).hash = "451dafdfdc57cc00acab96493d39a0bd";

export default node;
